import { VideoModal, useVideoModal } from './VideoModal';
VideoModal.useVideoModal = useVideoModal;
export default VideoModal;
